import React, { FunctionComponent, useState } from "react";
import { navigate } from "gatsby";
import { Layout } from "../components/layout";
import { PageHeader } from "../components/pageHeader";

const createFormDataObj = (data: any) => {
  const formData = new FormData();
  Object.keys(data).forEach((k) => {
    formData.append(k, data[k]);
  });
  return formData as any;
};

const FORM_NAME = "Contact Form";

export const NotFound: FunctionComponent = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    // This `data` object is what's passed to the createFormDataObj. It needs all of your form fields, where the key is the name= attribute and the value is the value=
    const data = {
      "form-name": FORM_NAME,
      FirstName: firstName,
      LastName: lastName,
      Email: email,
      Phone: phone,
      Message: message,
    };
    // This POSTs your encoded form to Netlify with the required headers (for text; headers will be different for POSTing a file) and, on success, redirects to the custom success page using Gatsby's `navigate` helper function that we imported at the top
    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams(createFormDataObj(data)).toString(),
    })
      .then(() => navigate("/contact-success"))
      .catch((error) => alert(error));
    // This is required to prevent the default onSubmit behavior
    e.preventDefault();
  };

  const field = (
    id: string,
    label: string,
    input: JSX.Element,
    hint?: string,
    wide = true
  ) => (
    <div className={`flex flex-col gap-1.5 ${wide ? "sm:col-span-2" : ""}`}>
      <div className="flex justify-between font-display text-ui">
        <label htmlFor={id} className="font-semibold">
          {label}
        </label>
        {hint && <span className="text-muted">{hint}</span>}
      </div>
      {input}
    </div>
  );

  return (
    <Layout>
      <PageHeader
        title="Contact me"
        deck="Questions about a build, a fix for a post, or just saying hi."
      />
      <form
        name={FORM_NAME}
        data-netlify="true"
        onSubmit={handleSubmit}
        action="/contact-success"
        method="POST"
        className="grid max-w-prose grid-cols-1 gap-6 px-gutter-sm pb-14 sm:grid-cols-2 md:px-gutter"
      >
        {field(
          "first_name",
          "First name",
          <input
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            name="FirstName"
            id="first_name"
            className="field"
          />,
          undefined,
          false
        )}
        {field(
          "last_name",
          "Last name",
          <input
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            name="LastName"
            id="last_name"
            className="field"
          />,
          undefined,
          false
        )}
        {field(
          "email",
          "Email",
          <input
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            name="Email"
            id="email"
            type="email"
            className="field"
          />
        )}
        {field(
          "phone",
          "Phone",
          <input
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            name="Phone"
            id="phone"
            className="field"
          />,
          "Optional"
        )}
        {field(
          "message",
          "Message",
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            name="Message"
            id="message"
            rows={4}
            maxLength={500}
            className="field"
          />,
          "Max. 500 characters"
        )}
        <div className="sm:col-span-2">
          <button type="submit" className="btn-primary">
            Submit
          </button>
        </div>
      </form>
    </Layout>
  );
};

export default NotFound;
